var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"list_counter_validator my-2 ml p-0",attrs:{"input-value":_vm.valid,"rules":[(v) => !!v || _vm.$t('formulaires.provinceEtCategorieIncompatibles')]}})
}
var staticRenderFns = []

export { render, staticRenderFns }